import React from 'react';
import styles from './styles.scss';
export const Tooltip = ({ children, content, }) => {
    return (React.createElement("div", { className: styles.tooltip },
        children,
        React.createElement("span", { className: styles.content, "aria-hidden": "true" }, content)));
};
//# sourceMappingURL=tooltip.js.map